import React, {useState} from "react";

const API = "https://live-evo.com/api/auth/staff";

function getBrowserDeviceId() {
  const key = "evo_staff_browser_device_id";
  let value =
    localStorage.getItem(key) ||
    sessionStorage.getItem(key);

  if (!value) {
    value = "web-" + crypto.randomUUID();
  }

  localStorage.setItem(key, value);
  return value;
}

function StaffLoginPage() {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [step, setStep] = useState("email");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const requestCode = async event => {
    event.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const response = await fetch(`${API}/request-code`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: email.trim().toLowerCase()
        })
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(
          data.error || "Adresse Staff non reconnue."
        );
      }

      setStep("code");
      setMessage(
        "Un code temporaire a été envoyé sur l’adresse personnelle du Staff."
      );
    } catch (error) {
      setMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  const verifyCode = async event => {
    event.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const response = await fetch(`${API}/verify-code`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: email.trim().toLowerCase(),
          code: code.trim(),
          device_id: getBrowserDeviceId(),
          device_type: "web"
        })
      });

      const data = await response.json();

      if (!response.ok || !data.success || !data.accessToken) {
        throw new Error(
          data.error || "Code incorrect ou appareil non autorisé."
        );
      }

      localStorage.setItem("evoAccessToken", data.accessToken);
      localStorage.setItem(
        "currentUser",
        JSON.stringify({
          email: data.email,
          role: data.role || "staff",
          is_staff: true
        })
      );

      window.location.href = "/staff";
    } catch (error) {
      setMessage(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main style={styles.page}>
      <section style={styles.card}>
        <div style={styles.icon}>🛡️</div>
        <div style={styles.eyebrow}>CENTRE STAFF EVO</div>
        <h1 style={styles.title}>Connexion Staff</h1>
        <p style={styles.text}>
          Utilise l’adresse Staff reçue par e-mail. Un nouveau code temporaire
          sera envoyé à chaque connexion.
        </p>

        {step === "email" ? (
          <form onSubmit={requestCode}>
            <input
              type="email"
              value={email}
              onChange={event => setEmail(event.target.value)}
              placeholder="staff-xxxxx@live-evo.com"
              required
              style={styles.input}
            />
            <button
              type="submit"
              disabled={loading}
              style={styles.button}
            >
              {loading ? "Envoi…" : "Recevoir mon code"}
            </button>
          </form>
        ) : (
          <form onSubmit={verifyCode}>
            <input
              type="text"
              value={code}
              onChange={event => setCode(event.target.value)}
              placeholder="Code reçu par e-mail"
              inputMode="numeric"
              required
              style={styles.input}
            />
            <button
              type="submit"
              disabled={loading}
              style={styles.button}
            >
              {loading ? "Vérification…" : "Ouvrir le Centre Staff"}
            </button>
          </form>
        )}

        {message && <p style={styles.message}>{message}</p>}

        {step === "code" && (
          <button
            type="button"
            onClick={() => {
              setStep("email");
              setCode("");
              setMessage("");
            }}
            style={styles.link}
          >
            Utiliser une autre adresse Staff
          </button>
        )}
      </section>
    </main>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "grid",
    placeItems: "center",
    padding: "24px",
    background: "radial-gradient(circle at top, #06344a, #01050b 58%)",
    color: "#fff"
  },
  card: {
    width: "min(430px, 100%)",
    padding: "30px",
    borderRadius: "24px",
    border: "1px solid #00eaff",
    background: "#04121f",
    boxShadow: "0 0 30px rgba(0,234,255,.18)"
  },
  icon: {
    fontSize: "40px",
    textAlign: "center"
  },
  eyebrow: {
    marginTop: "12px",
    color: "#00eaff",
    fontSize: "11px",
    fontWeight: "900",
    letterSpacing: "2px",
    textAlign: "center"
  },
  title: {
    margin: "10px 0",
    textAlign: "center"
  },
  text: {
    color: "#9bb3c7",
    lineHeight: 1.5
  },
  input: {
    width: "100%",
    boxSizing: "border-box",
    marginTop: "12px",
    padding: "14px",
    borderRadius: "12px",
    border: "1px solid #28627a",
    background: "#020910",
    color: "#fff",
    fontSize: "15px"
  },
  button: {
    width: "100%",
    marginTop: "14px",
    padding: "14px",
    border: 0,
    borderRadius: "12px",
    background: "linear-gradient(90deg, #00eaff, #6550ff)",
    color: "#fff",
    fontWeight: "900",
    cursor: "pointer"
  },
  message: {
    marginTop: "16px",
    color: "#ffd27a"
  },
  link: {
    marginTop: "16px",
    border: 0,
    background: "transparent",
    color: "#00eaff",
    cursor: "pointer"
  }
};

export default StaffLoginPage;
